export const NAME = 'create-project-modal';
